/**
 * A person's portrait, or their initials on the panel colour when they have none: a creator
 * card is identified at a glance either way, and nobody is shown a stock silhouette.
 */
import { coverUrl } from '../lib/api'

/** "Ana “Ringlov” Comor" -> "AR": the first letter of each word, skipping quotes and punctuation. */
const initials = (name: string) =>
  name
    .split(/\s+/)
    .map((w) => w.match(/\p{L}|\p{N}/u)?.[0] ?? '')
    .filter(Boolean)
    .slice(0, 2)
    .join('')
    .toUpperCase()

export function Portrait({ photo, name, size = 'md' }: { photo: string | null; name: string; size?: 'md' | 'lg' }) {
  const src = coverUrl(photo)
  return (
    <span className={`portrait portrait-${size}`} aria-hidden="true">
      {src ? <img src={src} alt="" loading="lazy" decoding="async" /> : <span>{initials(name)}</span>}
    </span>
  )
}
